import { RegisteredAssetDetailModel } from '@casops/store/apis/registeredAssetsApi';
import { MapViewProps } from '@cas/components/maps/map-view/MapView';
import usePositionsOnMap from './usePositionsOnMap';

export const useAssetPositionsOnMap = (
  asset: Pick<RegisteredAssetDetailModel, 'posG'> | undefined,
): MapViewProps => {
  return usePositionsOnMap(asset ? [asset.posG] : []);
};

export default useAssetPositionsOnMap;
